import React, { PureComponent } from 'react';
import {
  WithStyles,
  withStyles,
  createStyles,
  Theme,
} from '@lifeomic/chroma-react/styles';
import SurveyItem from '../../util/SurveyItem';
import { SurveyItemComponent } from '../SurveyItem';
import withCheckForEnablement, {
  WithCheckForEnablementInjectedProps,
} from '../hoc/withCheckForEnablement';
import getSurveyItemTestId from '../../util/getSurveyItemTestId';
import { getTestProps } from '../../../../util/testProps';

export const testIds = {
  detailRow: (linkId: string) => getSurveyItemTestId(linkId, 'detail-row'),
};

const styles = (theme: Theme) =>
  createStyles({
    detail: {
      width: '100%',
      marginTop: theme.spacing(1),
      padding: theme.spacing(1, 1.5),
      // Indent under the row label so the detail reads as nested beneath its
      // trigger rather than as a stray field on the next row.
      marginLeft: theme.spacing(2),
      maxWidth: `calc(100% - ${theme.spacing(2)})`,
      backgroundColor: theme.palette.grey[50],
      borderLeft: `3px solid ${theme.palette.grey[400]}`,
      borderRadius: theme.pxToRem(4),
      boxSizing: 'border-box',
    },
  });

export interface TableRowDetailOwnProps {
  surveyItem: SurveyItem;
}

export type TableRowDetailProps = TableRowDetailOwnProps &
  WithStyles<typeof styles> &
  WithCheckForEnablementInjectedProps;

/**
 * A table-group child marked with the table-row-detail modifierExtension.
 * Renders inside its trigger row (or after the trigger block on mobile). The
 * whole block is removed while the enableWhen condition is unmet, so an
 * unanswered or "No" row adds no empty space.
 */
class TableRowDetail extends PureComponent<TableRowDetailProps> {
  render() {
    const { surveyItem, isEnabled, classes } = this.props;

    if (!isEnabled) return null;

    return (
      <div
        className={classes.detail}
        {...getTestProps(testIds.detailRow(surveyItem.link))}
      >
        <SurveyItemComponent surveyItem={surveyItem} />
      </div>
    );
  }
}

export default withStyles(styles)(withCheckForEnablement(TableRowDetail));
